import script from "./CommonStatus.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonStatus.vue?vue&type=script&lang=ts&setup=true"

import "./CommonStatus.vue?vue&type=style&index=0&id=f049cd6e&scoped=true&lang=scss"
import "./CommonStatus.vue?vue&type=style&index=1&id=f049cd6e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f049cd6e"]])

export default __exports__